<a mat-list-item (click)="toggle()">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Programas e Projetos">
            <mat-icon>ballot</mat-icon>
            <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Programas e Projetos </span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>
<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

        <!-- PROGRAMAS -->
        <sub-menu  *ngIf="verificaAcesso(getModulos().PROGRAMAS)"  icone="apps" titulo="Programas" rota="programas" toolTip="Programas"></sub-menu>

        <!-- PROJETOS -->
        <sub-menu *ngIf="verificaAcesso(getModulos().PROJETO)"   icone="folder_open" titulo="Projetos" rota="projetos" toolTip="Projetos"></sub-menu>

        <!-- CONTRATOS -->
        <sub-menu *ngIf="verificaAcesso(getModulos().CONTRATO)"   icone="folder" titulo="Contratos" rota="contrato" toolTip="Contratos"></sub-menu>

        <!-- GESTAO DE PARCERIAS -->
        <sub-menu *ngIf="verificaAcesso(getModulos().EMPRESAS_PARCEIRAS)" icone="group_add" titulo="Gestão de Parcerias" rota="empresasparceiras" toolTip="Gestão de Parcerias"></sub-menu>
        
        <!-- EMPRESAS_CLIENTES-->
        <sub-menu *ngIf="verificaAcesso(getModulos().EMPRESAS_CLIENTES)" icone="group_add" titulo="Empresas Clientes" rota="empresasclientes" toolTip="Empresas Clientes"></sub-menu>

        <!-- PRESTACAO DE CONTAS -->
        <sub-menu *ngIf="verificaAcesso(getModulos().PRESTACAO_CONTAS)" icone="monetization_on" titulo="Prestação de contas" rota="home" toolTip="Prestação de contas"></sub-menu>
        
         <!-- TABELAS REFERENCIA -->
         <tb-referencia-programa-projeto></tb-referencia-programa-projeto>
    </div>
</mat-nav-list>